import { Formik } from 'formik';
import React from 'react';
import { Buttons, CancelButton, ModalCard, Button, Form, FormMessage, Field, HelpTooltip } from '~/components';
import { useForm } from '~/hooks';
import { useApi, useToast, useWorkspace } from '~/contexts';

function SetBookingTypeConfirmation({ project, resource, bookingTypeId, onSubmit, onClose }) {
  const api = useApi();
  const { workspace } = useWorkspace();
  const toast = useToast();
  const [{ isSubmitting, status, message }, form] = useForm();

  const typeLabel = bookingTypeId === 'soft' ? 'Soft' : 'Confirmed';
  const title = resource ? `Set Allocations to ${typeLabel}` : `Set All Allocations to ${typeLabel}`;

  const handleSubmit = async (values) => {
    form.submit(values);

    try {
      if (resource) {
        await api.www.workspaces(workspace.id).allocations().projectSchedule.setResourceBookingType(project.id, {
          resourceTypeId: resource.resourceType,
          resourceId: resource.id,
          bookingTypeId,
          includePastAllocations: values.includePastAllocations,
        });
      } else {
        await api.www.workspaces(workspace.id).allocations().projectSchedule.setProjectBookingType(project.id, {
          bookingTypeId,
          includePastAllocations: values.includePastAllocations,
        });
      }

      onClose();
      onSubmit();
      toast.success(`Allocations have been set to ${typeLabel}.`);
      form.done();
    } catch ({ message }) {
      form.error({ message });
    }
  };

  return (
    <ModalCard title={title} onClose={onClose}>
      <Formik
        enableReinitialize
        initialValues={{ includePastAllocations: false }}
        onSubmit={handleSubmit}
        validateOnBlur={false}
        validateOnChange={false}>
        <Form>
          <ModalCard.Body>
            {resource
              ? `This will set all allocations for ${resource.name} on the ${project.name} project within ${project.client.name} to ${typeLabel}.`
              : `This will set all allocations on the ${project.name} project within ${project.client.name} to ${typeLabel}.`}
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '1rem' }}>
              <Field.Checkbox name="includePastAllocations" label="Update past allocations" />
              <HelpTooltip
                style={{ marginLeft: '.5rem' }}
                message="If unchecked, only allocations ending today or later will be updated."
              />
            </div>
            {status && <FormMessage.Error spaceTop>{message}</FormMessage.Error>}
          </ModalCard.Body>
          <ModalCard.Footer>
            <Buttons align="right">
              <CancelButton onClick={onClose}>Cancel</CancelButton>
              <Button type="submit" isLoading={isSubmitting}>
                {`Set to ${typeLabel}`}
              </Button>
            </Buttons>
          </ModalCard.Footer>
        </Form>
      </Formik>
    </ModalCard>
  );
}

export default SetBookingTypeConfirmation;
